// import '@/assets/base.css'
import '@/assets/main.css'
import '@/assets/markdown.css'

import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { createApp } from 'vue'

import '@/dev/supabaseRequestTrace'
import App from '@/App.vue'
import router from '@/router'
import { useAuthStore } from '@/features/account/session'

const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.use(pinia)
app.use(router)

// Initialize auth before mounting the app.
const initializeApp = async (): Promise<void> => {
  const authStore = useAuthStore()
  await authStore.initialize()
  await router.isReady()
  app.mount('#app')
}

void initializeApp()
